import {
  CardSkeleton,
  ChartSkeleton,
  MetricGridSkeleton,
  SectionHeadingSkeleton,
  SkeletonElement,
  TableSkeleton
} from "@/components/Skeleton";
import { METRIC_CARD_MIN_WIDTH_PX } from "@/components/MetricGrid/metricGridLayout";

type Props = {
  includeFilters?: boolean;
};

function ChartCardSkeleton({ type }: { type: "pie" | "bar" }) {
  return (
    <div className="flex h-full w-full flex-col items-start rounded-lg border border-sys-brand-outline p-6">
      <SkeletonElement height="h-5" width="w-36" className="mb-6" />
      <ChartSkeleton type={type} />
    </div>
  );
}

export default function RosterActivityPageSkeleton({ includeFilters = false }: Props) {
  return (
    <div
      data-testid="roster-activity-page-skeleton"
      role="status"
      aria-busy="true"
      aria-label="Loading roster activity"
    >
      {includeFilters ? <CardSkeleton className="!w-full" width={100} rows={5} /> : null}
      <SectionHeadingSkeleton />
      <div className="flex flex-col gap-3">
        <MetricGridSkeleton cards={3} size="compact" hasHeading minCardWidth={METRIC_CARD_MIN_WIDTH_PX} />
        <div className="grid items-stretch gap-4 md:grid-cols-2">
          <ChartCardSkeleton type="bar" />
          <ChartCardSkeleton type="pie" />
        </div>
      </div>
      <TableSkeleton columns={5} rows={5} />
    </div>
  );
}
